export class UploadComprovanteRequestModel {
    constructor() {}

    public contaId: string;
    public depositoId: string;
    public pessoaId: string;
    public imagemId: string;
    public extensao: string;
    public mimeType: string;
    public imagemArray: string;
}
